var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropBoxIcoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49955 0L0 3.5609L5.49955 7.12189L11 3.5609L5.49955 0ZM16.4999 0L11 3.56125L16.4999 7.1225L22 3.56125L16.4999 0ZM0 10.6834L5.49955 14.2444L11 10.6834L5.49955 7.1225L0 10.6834ZM16.4999 7.1225L11 10.6838L16.4999 14.2449L21.9999 10.6838L16.4999 7.1225ZM5.49998 15.439L11.0004 19L16.4999 15.439L11.0004 11.8781L5.49998 15.439Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropBoxIcoGray);
export default __webpack_public_path__ + "static/media/dropBoxIcoGray.17b0c1774ea63c94bcfb62ad5d2e647b.svg";
export { ForwardRef as ReactComponent };